import request from '../../../shared/request'

export function getJobParts(job_id) {
  return request(`/job/parts/${job_id}/`)
}

export function addJobPart(payload) {
  return request(`/job/parts/${payload.job_part_data.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobPart(payload) {
  return request(`/job/parts/${payload.part_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobPart(part_id) {
  return request(`/job/parts/${part_id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/parts.js